import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import { Button } from '../../components/widgets';
import StepCard from '../../components/molecules/StepCard';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { EMPTY_STATE_TRANSLATIONS, EMPTY_STATE_STEPS } from '../consts';
import css from './AIDimensionsEmptyState.css';

const AIDimensionsEmptyState = ({ onCreateDimension, containerClass = '' }) => {
    return (
        <div className={classNames(css.container, containerClass)}>
            <div className={classNames(css.column, css.detailsPanel)}>
                <div className={css.badge}>
                    <Icon name="ai-line" size={IconSizes.SMALL} variant={IconVariants.ACTIVE} />
                    <span className={css.badgeLabel}>
                        <Translate id={EMPTY_STATE_TRANSLATIONS.BADGE_LABEL} />
                    </span>
                </div>
                <span className={css.title}>
                    <Translate id={EMPTY_STATE_TRANSLATIONS.TITLE} />
                </span>
                <span className={css.description}>
                    <Translate id={EMPTY_STATE_TRANSLATIONS.DESCRIPTION} />
                </span>
                <Button
                    type="primary"
                    onClick={onCreateDimension}
                    Icon="plus"
                    iconSize={IconSizes.X_SMALL}
                    text={EMPTY_STATE_TRANSLATIONS.CREATE_LABEL}
                />
            </div>
            <div className={css.column}>
                {EMPTY_STATE_STEPS.map(step => (
                    <StepCard key={step.index} {...step} />
                ))}
            </div>
        </div>
    );
};

AIDimensionsEmptyState.propTypes = {
    onCreateDimension: PropTypes.func.isRequired,
    containerClass: PropTypes.string,
};

export default AIDimensionsEmptyState;
